<form [formGroup]="form.formGroup" class="flex flex-col space-y-2">

  <app-uom-input
    label="Surface Pressure"
    [unitLabel]="pressureLabel"
    [formControlName]="form.formControlNames.surfacePressure"
    [control]="'surfacePressure'"
    [min]="pressureValidation.min"
    [max]="pressureValidation.max"
    [default]="'0'"
    title="Allowed range: {{ pressureValidation.min }} - {{ pressureValidation.max }} {{ pressureLabel }}"
  />

  <app-uom-input
    label="Fluid Density"
    [unitLabel]="densityLabel"
    [formControlName]="form.formControlNames.fluidDensity"
    [control]="'fluidDensity'"
    [min]="densityValidation.min"
    [max]="densityValidation.max"
    [default]="currentString.annularFluid?.state.nominalDensity"
    title="Allowed range: {{ densityValidation.min }} - {{ densityValidation.max }} {{ densityLabel }}"
  />

  <div class="w-full">
    <p-checkbox
      size="small"
      binary="true"
      [formControlName]="form.formControlNames.hasPlug"
      (change)="pressureTestPlugChange()"
      inputId="hasPlug"
    />
    <label class="pl-2" for="hasPlug">Has Plug</label>
  </div>

  <app-uom-input
    label="Plug Depth"
    [unitLabel]="userUnits.longLengths + ' MD'"
    [formControlName]="form.formControlNames.plugMd"
    [control]="'plugMd'"
    [min]="currentString.hangerMd + 1"
    [max]="currentString.shoeMd"
    [default]="null"
    (focusout)="setPlugDepth()"
    [inputDisabled]="plugDepthDisabled"
    title="Allowed range: {{ currentString.hangerMd + 1 }} - {{ currentString.shoeMd }} {{ userUnits.longLengths }} MD"
  />
</form>
